import IIssuingAuthorityVm from "./../issuingAuthority/IIssuingAuthorityVm"
import IEducationalInstitutionVm from "./IEducationalInstitutionVm"
import IUserVm from "./IUserVm"

import * as IUserVmInstance from "./IUserVm"
import * as IEducationalInstitutionVmInstance from "./IEducationalInstitutionVm"
import * as IIssuingAuthorityVmInstance from "./../issuingAuthority/IIssuingAuthorityVm"

export default interface ICommentVm {
    id?: string
    applicationId: string
    lastEditedByUser: IUserVm
    text: string
    associatedEducationalInstitution: IEducationalInstitutionVm
    associatedIssuingAuthority: IIssuingAuthorityVm
}

export const empty = (enableIteration: boolean = true): ICommentVm => {
	return {
		id: "",
		applicationId: "",
		lastEditedByUser: IUserVmInstance.empty(),
		text: "",
		associatedEducationalInstitution: IEducationalInstitutionVmInstance.empty(),
		associatedIssuingAuthority: IIssuingAuthorityVmInstance.empty()
	} as ICommentVm
}